import { render, staticRenderFns } from "./secondary-kpi-delete-lightbox.vue?vue&type=template&id=347fb6a6&scoped=true"
import script from "./secondary-kpi-delete-lightbox.vue?vue&type=script&lang=ts"
export * from "./secondary-kpi-delete-lightbox.vue?vue&type=script&lang=ts"
import style0 from "./secondary-kpi-delete-lightbox.vue?vue&type=style&index=0&id=347fb6a6&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "347fb6a6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('347fb6a6')) {
      api.createRecord('347fb6a6', component.options)
    } else {
      api.reload('347fb6a6', component.options)
    }
    module.hot.accept("./secondary-kpi-delete-lightbox.vue?vue&type=template&id=347fb6a6&scoped=true", function () {
      api.rerender('347fb6a6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/formula-step/secondary-kpi-tab/secondary-kpi-delete-lightbox.vue"
export default component.exports